import React, { useState, useEffect } from "react";
import Person1 from '../../Images/person1.jpg';
import Person2 from '../../Images/person2.jpg';
import Person3 from '../../Images/Person3.jpg';
import Person4 from '../../Images/person4.jpg';
import Person5 from '../../Images/person5.jpg';
import Person6 from '../../Images/person6.jpg';

function Layer4() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [autoHoverIndex, setAutoHoverIndex] = useState(0);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [animationKey, setAnimationKey] = useState(0); // To force SVG re-render

  const team = [
    {
      name: "Lokesh",
      role: "#Banking Sector | BFSI",
      verifications: {
        ID: "ID Verified",
        Criminal: "Criminal Background Verified",
        Address: "Address Verified",
        Employment: "Employment Verified"
      },
      image: Person6
    },
    {
      name: "Sakshi",
      role: "#Medical Practitioner",
      verifications: {
        ID: "ID Verified",
        Criminal: "Criminal Background Verified",
        Education: "Education Verified",
        Employment: "Employment Verified",
        Registration: "Registration Certificate Verified"
      },
      image: Person4,
    },
    {
      name: "Bhagat Singh",
      role: "#Driver",
      verifications: {
        ID: "ID Verified",
        Criminal: "Criminal Background Verified",
        Driving: "Driving License Verified",
        Address: "Address Verified"
      },
      image: Person2
    },
    {
      name: "Jennifer",
      role: "#Teacher",
      verifications: {
        ID: "ID Verified",
        Criminal: "Criminal Background Verified",
        Education: "Education Verified",
        Employment: "Employment Verified"
      },
      image: Person5
    },
    {
      name: "Kumar",
      role: "#Housekeeping",
      verifications: {
        ID: "ID Verified",
        Criminal: "Criminal Background Verified",
        Address: "Address Verified"
      },
      image: Person3
    },
    {
      name: "Abbubakker",
      role: "#Designer",
      verifications: {
        ID: "ID Verified",
        Criminal: "Criminal Background Verified",
        Education: "Education Verified",
        Employment: "Employment Verified"
      },
      image: Person1
    },
  ];

  // Auto-hover for profile cards
  useEffect(() => {
    const interval = setInterval(() => {
      setAutoHoverIndex((prevIndex) => (prevIndex + 1) % team.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [team.length]);

  // Animation reset for ticks every 5 seconds when popup is open
  useEffect(() => {
    if (isPopupVisible) {
      const interval = setInterval(() => {
        setAnimationKey((prevKey) => prevKey + 1); // Forces re-render of SVGs
      }, 5000); // Every 5 seconds
      return () => clearInterval(interval);
    }
  }, [isPopupVisible]);

  const handleKnowMoreClick = (member) => {
    setSelectedMember(member);
    setIsPopupVisible(true);
    setAnimationKey(0); // Reset animation key when opening popup
  };

  const closePopup = () => {
    setIsPopupVisible(false);
    setSelectedMember(null);
  };

  const renderVerificationItem = (key, value, index) => {
    return (
      <p
        className="mb-3 text-lg flex items-center animate-fade-in-up"
        style={{ animationDelay: `0.${3 + index}s` }}
      >
        <svg
          key={animationKey + index} // Unique key to force re-render
          className="w-6 h-6 mr-2 text-[#00cc00] animate-verify-tick"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          strokeWidth="2"
        >
          <circle
            className="circle-path"
            cx="12"
            cy="12"
            r="10"
            fill="none"
            strokeWidth="2"
          />
          <path
            className="tick-path"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 12l3 3l5-6"
          />
        </svg>
        <span className="font-medium">{key}:</span> {value}
      </p>
    );
  };

  return (
    <div className="min-h-screen bg-black py-16 px-4 select-none">
      <h2 className="text-white mb-10 font-thin text-[30px] text-center">
        Verified <span className="text-[#b7372e] font-bold">Profiles</span>
      </h2>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch">
          {team.map((member, index) => (
            <div
              key={index}
              className={`relative overflow-hidden transition-all duration-500 ease-in-out
                ${hoveredIndex === index || autoHoverIndex === index ? "z-20 scale-105" : "z-10"}`}
              onMouseEnter={() => {
                setHoveredIndex(index);
                setAutoHoverIndex(null);
              }}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="aspect-[3/4] min-h-72 md:min-h-80 lg:min-h-96 relative group cursor-pointer">
                <img
                  src={member.image}
                  alt={member.name}
                  className={`w-full h-full object-cover transition-all duration-500
                    ${
                      (hoveredIndex !== null && hoveredIndex !== index && autoHoverIndex !== index) ||
                      (autoHoverIndex !== null && autoHoverIndex !== index)
                        ? "grayscale brightness-50"
                        : "grayscale-0 brightness-100 scale-110"
                    }`}
                />
                <div
                  className={`absolute inset-0 bg-gradient-to-t from-black/80 to-transparent transition-opacity duration-300
                    ${hoveredIndex === index || autoHoverIndex === index ? "opacity-100" : "opacity-0"}`}
                >
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <h3 className="text-white text-2xl font-semibold mb-1">{member.name}</h3>
                    <p className="text-gray-300 text-lg">{member.role}</p>
                    {(hoveredIndex === index || autoHoverIndex === index) && (
                      <div className="mt-4 flex items-center justify-end">
                        <button
                          className="text-white text-lg group flex items-center hover:text-[#b7372e] transition-colors"
                          onClick={() => handleKnowMoreClick(member)}
                        >
                          <span className="underline decoration-[#b7372e] decoration-2 underline-offset-4 mr-2">
                            Know more
                          </span>
                          <svg
                            className="w-6 h-6 text-white group-hover:text-[#b7372e] transform group-hover:translate-x-1 transition-all"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M17 8l4 4m0 0l-4 4m4-4H3"
                            />
                          </svg>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {isPopupVisible && selectedMember && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50 p-4 animate-slide-in-fade"
          onClick={closePopup}
        >
          <div
            className="bg-white p-6 rounded-lg shadow-lg flex flex-col md:flex-row max-w-4xl w-11/12 md:w-3/4"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedMember.image}
              alt={selectedMember.name}
              className="w-full md:w-2/5 h-72 md:h-96 object-cover rounded-lg mb-4 md:mb-0 md:mr-6 animate-fade-in-up"
              style={{ animationDelay: '0.1s' }}
            />
            <div className="flex flex-col justify-center flex-grow">
              <h3
                className="text-3xl font-semibold mb-4 animate-fade-in-up"
                style={{ animationDelay: '0.2s' }}
              >
                {selectedMember.name}
              </h3>
              <p
                className="mb-3 text-lg animate-fade-in-up"
                style={{ animationDelay: '0.3s' }}
              >
                <span className="font-medium">Role:</span> {selectedMember.role}
              </p>
              {Object.entries(selectedMember.verifications).map(([key, value], index) =>
                renderVerificationItem(key, value, index)
              )}
              <button
                className="mt-6 bg-[#b7372e] text-white py-3 px-6 rounded-lg self-end hover:bg-red-700 transition-colors text-lg animate-fade-in-up"
                style={{ animationDelay: '0.5s' }} // Fixed back to 0.5s
                onClick={closePopup}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .animate-slide-in-fade {
          animation: slideInFade 0.4s ease-out forwards;
        }
        @keyframes slideInFade {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.3s ease-out forwards;
          opacity: 0;
        }
        @keyframes fadeInUp {
          0% { opacity: 0; transform: translateY(10px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .animate-verify-tick .circle-path {
          stroke-dasharray: 63; /* Circumference of circle with r=10 */
          stroke-dashoffset: 63;
          animation: drawCircle 1s ease-out infinite;
        }
        .animate-verify-tick .tick-path {
          stroke-dasharray: 15; /* Length of the tick path */
          stroke-dashoffset: 15;
          animation: drawTick 1s ease-out 1s infinite; /* Delayed after circle */
        }
        @keyframes drawCircle {
          0% { stroke-dashoffset: 63; }
          100% { stroke-dashoffset: 0; }
        }
        @keyframes drawTick {
          0% { stroke-dashoffset: 15; }
          100% { stroke-dashoffset: 0; }
        }
      `}</style>
    </div>
  );
}

export default Layer4;